import { Box, Text, CloseButton } from '@chakra-ui/react';

export default function TopBanner({ visible, setVisible }) {
  if (!visible) return null;

  const handleClose = () => {
    setVisible(false);
    localStorage.setItem('gestar_top_banner_hidden', 'true');
  };

  return (
    <Box
      bg="blue.600"
      color="white"
      px={4}
      py={3}
      textAlign="center"
      position="fixed"
      top="0"
      left="0"
      right="0"
      zIndex={1100}
    >
      <Text fontWeight="bold">
       🎉 35% off y cuotas sin interés por el mes del amigo. ✅ Cupos limitados
      </Text>
      <CloseButton
        position="absolute"
        right="10px"
        top="10px"
        onClick={handleClose}
      />
    </Box>
  );
}
